import { useCallback, useEffect, useState } from 'react'
import { getContainerWidth, getContainerHeight } from '../../container-sizes'
import { useAppStore } from '../../shared/store/store'

export function useContainerRef() {
  const [container, setContainer] = useState<HTMLElement | null>()
  const setWidth = useAppStore((state) => state.setWidth)
  const setHeight = useAppStore((state) => state.setHeight)

  useEffect(() => {
    if (!container) return

    const resizeObserver = new ResizeObserver(() => {
      setWidth(getContainerWidth(container))
      setHeight(getContainerHeight(container))
    })

    resizeObserver.observe(container)

    return () => {
      resizeObserver.disconnect()
    }
  }, [container])

  const onContainerRefChange = useCallback((node: HTMLElement | null) => {
    setContainer(node)
  }, [])

  return [container, onContainerRefChange] as const
}
